import { Component, HostBinding, OnInit } from "@angular/core";
import { AppService } from "@services/app.service";
import { Subject, takeUntil } from "rxjs";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NewJoinForms } from "@/model/new-joining-form/new_JoinForms";

@Component({
  selector: "app-new-joining-form-report",
  templateUrl: "./new-joining-form-report.component.html",
  styleUrls: ["./new-joining-form-report.component.scss"]
})

export class NewJoiningFormReportComponent implements OnInit {
  searchText: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  datePipe: DatePipe = new DatePipe("en-IN");
  getAllEmployees: NewJoinForms[] = [];
  employeeData: NewJoinForms[] = [];
  entryEdit: NewJoinForms | undefined;
  isMapShow = false;
  isViewShow = false;
  bankDetails = true;
  trainerDisable = true;
  imageUrl: string = "";
  imgPlace: HTMLElement | undefined;
  filteredEmployees: NewJoinForms[] = [];
  currentDate: string | null = null;
  fileType: string = "";
  disablenav = true;
  userType: string = "";
  viewDocument: boolean = true;
  WorkingLocationList: string[] = [];
  employeeTypeList: string[] = [];
  designationList: string[] = [];
  workingStatus: string[] = [];
  workingLocationFilter: string | null = null;
  employeeTypeFilter: string | null = null;
  designationFilter: string | null = null;
  workingStatusFilter: string | null = null;

  constructor(private appService: AppService, private tostar: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router) {
    this.currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd") || null;
  }

  ngOnInit() {
    this.getJoinDetails();
    this.userType = localStorage.getItem('userType');
  }

  getJoinDetails() {
    this.spinner.show();
    this.appService.getJoinDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.getAllEmployees = data.sort((a, b) => {
          const idA = parseInt(a.newJoinId.split("-")[1]);
          const idB = parseInt(b.newJoinId.split("-")[1]);
          return idB - idA;
        });
        this.filteredEmployees = this.getAllEmployees.filter(item => item.workingStatus == "WORKING");
        this.WorkingLocationList = Array.from(new Set(this.getAllEmployees.map(item => item.location)))
        this.employeeTypeList = Array.from(new Set(this.getAllEmployees.map(item => item.employeeType)))
        this.designationList = Array.from(new Set(this.getAllEmployees.map(item => item.designation)))
        this.workingStatus = Array.from(new Set(this.getAllEmployees.map(item => item.workingStatus)))
      }, (error: any) => {
        this.spinner.hide();
        this.tostar.error(error.error.message || "Something went wrong,please try again...")
        console.log("something went wrong:", error);
      });
  }

photoView(id: number) {
  this.spinner.show();
  this.appService.fileGet(id) // emits string URL now
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (fileURL: string) => {   // string, not Blob
        window.open(fileURL, '_blank'); 
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
        this.tostar.error("Something went wrong or no document uploaded");
      }
    );
}




  employeeFilter(event: any, filterType: string): void {
    const value = event.target.value;

    switch (filterType) {
      case 'location':
        this.workingLocationFilter = value !== 'all' ? value : null;
        break;
      case 'employee':
        this.employeeTypeFilter = value !== 'all' ? value : null;
        break;
      case 'designation':
        this.designationFilter = value !== 'all' ? value : null;
        break;
      case 'status':
        this.workingStatusFilter = value !== 'all' ? value : null;
        break;
    }

    this.applyFilter();
  }

  applyFilter(): void {
    this.filteredEmployees = this.getAllEmployees.filter(employee => {
      return (
        (!this.workingLocationFilter || employee.location === this.workingLocationFilter) &&
        (!this.employeeTypeFilter || employee.employeeType === this.employeeTypeFilter) &&
        (!this.designationFilter || employee.designation === this.designationFilter) &&
        (!this.workingStatusFilter || employee.workingStatus === this.workingStatusFilter)
      );
    });
  }

  clearFilter(): void {
    this.workingLocationFilter = "";
    this.employeeTypeFilter = "";
    this.designationFilter = "";
    this.workingStatusFilter = "";
    this.searchText = '';
    this.filteredEmployees = this.getAllEmployees;
  }


  close() {
    this.isMapShow = false;
  }

  openModel(newJoinId: String) {
    this.disablenav = false;
    this.spinner.show();
    var viewData: NewJoinForms | undefined;

    for (let model of this.filteredEmployees) {
      if (newJoinId == model.newJoinId) {
        viewData = model;
        this.spinner.hide();
        if (model.employeeType == "Trainne" || model.stipend == "Yes") {
          this.trainerDisable = true;
          this.bankDetails = true;
        } else if (model.stipend == "No") {
          this.bankDetails = false;
          this.trainerDisable = true;
        } else if (model.employeeType !== "Trainne") {
          this.bankDetails = true;
          this.trainerDisable = false;
        }
      }
    }
    //@ts-ignore
    this.employeeData.push(viewData);
    this.isViewShow = true;
  }

  selectExperiencesUlr(newJoinId: string) {
    for (var data of this.filteredEmployees) {
      const allDetails = data;
      var localdate: string | undefined;


    }
  }

  selectNewJoinLetter(newJoinId: string) {
    for (var data of this.filteredEmployees) {
      const allDetails = data;
      var localdate: string | undefined;


    }
  }

  // ngOnDestroy(): void {
  //   this.dataService.printData = this.entryEdit;
  // }

  close1() {
    this.isViewShow = false;
    this.employeeData = [];
    this.trainerDisable = false;
  }

  editDetails(formId: number) {
    const encodedId = btoa(formId.toString());
    this.router.navigate(['/main/new-joining-form']);
    localStorage.setItem("formId", encodedId)
  }

  print(employeeId: string) {
    this.spinner.show();
    let viewData: NewJoinForms | undefined;

    for (let model of this.filteredEmployees) {
      if (employeeId == model.newJoinId) {
        viewData = model;
        this.spinner.hide();
        if (model.employeeType == "Trainne" || model.stipend == "Yes") {
          this.trainerDisable = true;
          this.bankDetails = true;
        } else if (model.stipend == "No") {
          this.bankDetails = false;
          this.trainerDisable = true;
        } else if (model.employeeType !== "Trainne") {
          this.bankDetails = true;
          this.trainerDisable = false;
        }
      }
    }

    // @ts-ignore
    this.employeeData.push(viewData);
    this.isViewShow = true;
    this.viewDocument = false;
    setTimeout(() => {
      const printContent = document.getElementById("printableArea");
      if (printContent) {
        const printWindow = window.open("", "_blank");
        if (printWindow) {
          printWindow.document.write(`
            <html>
              <head>
                <title>Print</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                  }
                  table {
                    width: 100%;
                    border-collapse: collapse;
                  }
                  table, th, td {
                    border: 1px solid black;
                  }
                  th {
                    padding: 7px;
                    text-align: left;
                    width: 30%;
                  }
                   td {
                    padding: 7px;
                    text-align: left;
                    width: 60%;
                  }
                  @media print {
                    body {
                      font-size: 16px;
                    }
                  }
                </style>
              </head>
              <body>
                ${printContent.innerHTML}
              </body>
            </html>
          `);
          printWindow.document.close();
          printWindow.focus();
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        }
      }
    }, 1000);

    setTimeout(() => {
      this.isViewShow = false;
      this.viewDocument = true;
    }, 3000);
  }



}

